import { TransactionLabel } from "../types/user-transaction.entity";

export const UserTransactionLabelDisplay: Record<TransactionLabel, string> = {
  BOOKED_MEETING: "Booked meeting",
  UPCOMING_MEETING: "Upcoming meeting",
  BOOKING_REQUEST: "Booking request",
  REFUND_DECLINED_REQUEST: "Refund declined request",
  REFUND_CANCELLED_MEETING: "Refund cancelled meeting",
  REFUND_EXPIRED_REQUEST: "Refund expired request",
  REFUND_COACH_MISSED_MEETING: "Refund coach missed meeting",
  COMPLETED_MEETING: "Completed meeting",
  MEETING_EXTENSION_PAYMENT: "Meeting extension payment",
  MEETING_EXTENSION_PAYOUT: "Meeting extension payout",
  DIRECT_CALL: "Direct call",
  LOUNGE_DIRECT_CALL: "Lounge direct call",
  TOP_UP: "Top up",
  KARMA_PURCHASE: "Karma purchase",
  MONEY_WITHDRAWAL: "Money withdrawal",
  COMPLETE_PROFILE: "Complete profile",
  LEFT_A_WORD_REFLECTION: "Left a word/reflection",
  AI_PRACTICE: "AI practice",
  REWARD_FOR_CANCELLED_SESSION: "Reward for cancelled session",
  REGISTER_COINS: "Register coins",
  CANCELLED_MEETING: "Cancelled meeting",
  PARTIAL_PAYOUT_CANCELLED_MEETING: "Partial payout cancelled meeting",
  FULL_PAYOUT_OF_CANCELLED_MEETING: "Full payout of cancelled meeting",
  REFERRAL_REWARD: "Referral reward",
  ADMIN_SESSION_DEDUCTION: "Deduction by admin",
  ADMIN_SESSION_REFUND: "Refund by admin",
};
